import { render, staticRenderFns } from "./MdtfAdd.vue?vue&type=template&id=dd320e2a&scoped=true&"
import script from "./MdtfAdd.vue?vue&type=script&lang=js&"
export * from "./MdtfAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd320e2a",
  null
  
)

export default component.exports